module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item",
      style: ({
        'background-image': 'url(' + item.img + ')'
      })
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "cols s_24 l_12"
    }, [_c('div', {
      staticClass: "wrapper"
    }, [(item.title) ? _c('p', {
      staticClass: "title",
      style: (("color: " + (item.titleColor))),
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (item.text) ? _c('p', {
      staticClass: "text",
      style: (("color: " + (item.textColor))),
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      class: item.button2 || item.link2 ? 'buttonWr smallBtn' : 'buttonWr'
    }, [(item.link) ? _c('a', {
      staticClass: "btn waves-effect waves-light",
      style: (("color: " + (item.textColor))),
      attrs: {
        "href": item.link.href
      }
    }, [_vm._v(_vm._s(item.link.textButton))]) : (item.button) ? _c('a', {
      staticClass: "btn waves-effect waves-light",
      style: (("background-color: " + (item.titleColor))),
      attrs: {
        "data-fancybox": "",
        "href": ("#" + (item.button.popupFormID)),
        "data-key": item.button.key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.button.textButton) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.link2) ? _c('a', {
      staticClass: "btn waves-effect waves-light",
      attrs: {
        "href": item.link2.href
      }
    }, [_vm._v(_vm._s(item.link2.textButton))]) : (item.button2) ? _c('a', {
      staticClass: "btn waves-effect waves-light",
      style: (("background-color: " + (item.titleColor))),
      attrs: {
        "data-fancybox": "",
        "href": ("#" + (item.button2.popupFormID)),
        "data-key": item.button2.key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.button2.textButton) + "\n\t\t\t\t\t\t")]) : _vm._e()])])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0d300a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/mainSlider.vue
// module id = 257
// module chunks = 38